import { createSlice } from "@reduxjs/toolkit";
import {
  CustomerBalance,
  PaymentsReceived,
  Sales,
  CreditNoteDetails,
  InvoiceDetail,
  CustomerBalanceSummary,
  PayableDetails,
  PayableSummary,
  ReceivableDetails,
  ReceivableSummary,
  ExpenseDetails,
  ExpensesByProject,
  ExpenseByCategory,
  VendorBalances,
  VendorBalancesSummary,
  TimeToGetPaid,
  PurchaseByItem,
  BillDetails,
  BillPaymentsMade,
  VendorCreditDetails,
  PurchaseByVendor,
  BillableAmount,
  ExpensesByEmployees,
  ExpensesByClient,
  AccountTransactions,
  AccountTypeSummary,
  GeneralLedger,
  DetailedGeneralLedger,
  JournalReport,
  TrialBalance,
  TimesheetProfitabilitySummary,
  ProjectSummary,
  ProjectDetails,
  ProjectCostSummary,
  ProjectRevenueSummary,
  ProjectsPerformanceSummary,
} from "../../interfaces/reports";

interface Index {
  projectId: string;
  // Customer Balance Sheet
  customerBalance: CustomerBalance[];
  customerBalanceLoading: boolean;
  customerBalanceError: string;
  customerBalancePageNo: number;
  customerBalancePageSize: number;
  customerBalanceTotalPages: number;
  customerBalanceFromDate: string;
  customerBalanceToDate: string;
  //   Payments Recieved
  paymentsRecieved: PaymentsReceived[];
  paymentsRecievedLoading: boolean;
  paymentsRecievedError: string;
  paymentsRecievedPageNo: number;
  paymentsRecievedPageSize: number;
  paymentsRecievedTotalPages: number;
  paymentsRecievedFromDate: string;
  paymentsRecievedToDate: string;
  //   Sales
  sales: Sales[];
  salesLoading: boolean;
  salesError: string;
  salesPageNo: number;
  salesPageSize: number;
  salesTotalPages: number;
  salesFromDate: string;
  salesToDate: string;
  //   Credit Note Details
  creditNoteDetails: CreditNoteDetails[];
  creditNoteDetailsLoading: boolean;
  creditNoteDetailsError: string;
  creditNoteDetailsPageNo: number;
  creditNoteDetailsPageSize: number;
  creditNoteDetailsTotalPages: number;
  creditNoteDetailsFromDate: string;
  creditNoteDetailsToDate: string;
  // Invoice Details
  invoiceDetails: InvoiceDetail[];
  invoiceDetailsLoading: boolean;
  invoiceDetailsError: string;
  invoiceDetailsPageNo: number;
  invoiceDetailsPageSize: number;
  invoiceDetailsTotalPages: number;
  invoiceDetailsFromDate: string;
  invoiceDetailsToDate: string;
  // Customer Balance Summary
  customerBalanceSummary: CustomerBalanceSummary[];
  customerBalanceSummaryLoading: boolean;
  customerBalanceSummaryError: string;
  customerBalanceSummaryPageNo: number;
  customerBalanceSummaryPageSize: number;
  customerBalanceSummaryTotalPages: number;
  customerBalanceSummaryFromDate: string;
  customerBalanceSummaryToDate: string;
  // Payable Details
  payableDetails: PayableDetails[];
  payableDetailsLoading: boolean;
  payableDetailsError: string;
  payableDetailsPageNo: number;
  payableDetailsPageSize: number;
  payableDetailsTotalPages: number;
  payableDetailsFromDate: string;
  payableDetailsToDate: string;
  // Payable Summary
  payableSummary: PayableSummary[];
  payableSummaryLoading: boolean;
  payableSummaryError: string;
  payableSummaryPageNo: number;
  payableSummaryPageSize: number;
  payableSummaryTotalPages: number;
  payableSummaryFromDate: string;
  payableSummaryToDate: string;
  // Receivable Details
  receivableDetails: ReceivableDetails[];
  receivableDetailsLoading: boolean;
  receivableDetailsError: string;
  receivableDetailsPageNo: number;
  receivableDetailsPageSize: number;
  receivableDetailsTotalPages: number;
  receivableDetailsFromDate: string;
  receivableDetailsToDate: string;
  // Receivable Summary
  receivableSummary: ReceivableSummary[];
  receivableSummaryLoading: boolean;
  receivableSummaryError: string;
  receivableSummaryPageNo: number;
  receivableSummaryPageSize: number;
  receivableSummaryTotalPages: number;
  receivableSummaryFromDate: string;
  receivableSummaryToDate: string;
  // Expense Details
  expenseDetails: ExpenseDetails[];
  expenseDetailsLoading: boolean;
  expenseDetailsError: string;
  expenseDetailsPageNo: number;
  expenseDetailsPageSize: number;
  expenseDetailsTotalPages: number;
  expenseDetailsFromDate: string;
  expenseDetailsToDate: string;
  // Expenses By Project
  expensesByProject: ExpensesByProject[];
  expensesByProjectLoading: boolean;
  expensesByProjectError: string;
  expensesByProjectPageNo: number;
  expensesByProjectPageSize: number;
  expensesByProjectTotalPages: number;
  expensesByProjectFromDate: string;
  expensesByProjectToDate: string;
  // Expense By Category
  expenseByCategory: ExpenseByCategory[];
  expenseByCategoryLoading: boolean;
  expenseByCategoryError: string;
  expenseByCategoryPageNo: number;
  expenseByCategoryPageSize: number;
  expenseByCategoryTotalPages: number;
  expenseByCategoryFromDate: string;
  expenseByCategoryToDate: string;
  // Vendor Balances
  vendorBalances: VendorBalances[];
  vendorBalancesLoading: boolean;
  vendorBalancesError: string;
  vendorBalancesPageNo: number;
  vendorBalancesPageSize: number;
  vendorBalancesTotalPages: number;
  vendorBalancesFromDate: string;
  vendorBalancesToDate: string;
  // Vendor Balances Summary
  vendorBalancesSummary: VendorBalancesSummary[];
  vendorBalancesSummaryLoading: boolean;
  vendorBalancesSummaryError: string;
  vendorBalancesSummaryPageNo: number;
  vendorBalancesSummaryPageSize: number;
  vendorBalancesSummaryTotalPages: number;
  vendorBalancesSummaryFromDate: string;
  vendorBalancesSummaryToDate: string;
  // Time To Get Paid
  timeToGetPaid: TimeToGetPaid[];
  timeToGetPaidLoading: boolean;
  timeToGetPaidError: string;
  timeToGetPaidPageNo: number;
  timeToGetPaidPageSize: number;
  timeToGetPaidTotalPages: number;
  timeToGetPaidFromDate: string;
  timeToGetPaidToDate: string;
  // Purchase By Item
  purchaseByItem: PurchaseByItem[];
  purchaseByItemLoading: boolean;
  purchaseByItemError: string;
  purchaseByItemPageNo: number;
  purchaseByItemPageSize: number;
  purchaseByItemTotalPages: number;
  purchaseByItemFromDate: string;
  purchaseByItemToDate: string;
  // Bill Details
  billDetails: BillDetails[];
  billDetailsLoading: boolean;
  billDetailsError: string;
  billDetailsPageNo: number;
  billDetailsPageSize: number;
  billDetailsTotalPages: number;
  billDetailsFromDate: string;
  billDetailsToDate: string;
  // Bill Payments Made
  billPaymentsMade: BillPaymentsMade[];
  billPaymentsMadeLoading: boolean;
  billPaymentsMadeError: string;
  billPaymentsMadePageNo: number;
  billPaymentsMadePageSize: number;
  billPaymentsMadeTotalPages: number;
  billPaymentsMadeFromDate: string;
  billPaymentsMadeToDate: string;
  // Vendor Credit Details
  vendorCreditDetails: VendorCreditDetails[];
  vendorCreditDetailsLoading: boolean;
  vendorCreditDetailsError: string;
  vendorCreditDetailsPageNo: number;
  vendorCreditDetailsPageSize: number;
  vendorCreditDetailsTotalPages: number;
  vendorCreditDetailsFromDate: string;
  vendorCreditDetailsToDate: string;
  // Purchase By Vendor
  purchaseByVendor: PurchaseByVendor[];
  purchaseByVendorLoading: boolean;
  purchaseByVendorError: string;
  purchaseByVendorPageNo: number;
  purchaseByVendorPageSize: number;
  purchaseByVendorTotalPages: number;
  purchaseByVendorFromDate: string;
  purchaseByVendorToDate: string;
  // Billable Amount
  billableAmount: BillableAmount[];
  billableAmountLoading: boolean;
  billableAmountError: string;
  billableAmountPageNo: number;
  billableAmountPageSize: number;
  billableAmountTotalPages: number;
  billableAmountFromDate: string;
  billableAmountToDate: string;
  // Expenses By Employees
  expensesByEmployees: ExpensesByEmployees[];
  expensesByEmployeesLoading: boolean;
  expensesByEmployeesError: string;
  expensesByEmployeesPageNo: number;
  expensesByEmployeesPageSize: number;
  expensesByEmployeesTotalPages: number;
  expensesByEmployeesFromDate: string;
  expensesByEmployeesToDate: string;
  // Expenses By Client
  expensesByClient: ExpensesByClient[];
  expensesByClientLoading: boolean;
  expensesByClientError: string;
  expensesByClientPageNo: number;
  expensesByClientPageSize: number;
  expensesByClientTotalPages: number;
  expensesByClientFromDate: string;
  expensesByClientToDate: string;
  // Account Transactions
  accountTransactions: AccountTransactions[];
  accountTransactionsLoading: boolean;
  accountTransactionsError: string;
  accountTransactionsPageNo: number;
  accountTransactionsPageSize: number;
  accountTransactionsTotalPages: number;
  accountTransactionsFromDate: string;
  accountTransactionsToDate: string;
  // Account Type Summary
  accountTypeSummary: AccountTypeSummary[];
  accountTypeSummaryLoading: boolean;
  accountTypeSummaryError: string;
  accountTypeSummaryPageNo: number;
  accountTypeSummaryPageSize: number;
  accountTypeSummaryTotalPages: number;
  accountTypeSummaryFromDate: string;
  accountTypeSummaryToDate: string;
  // General Ledger
  generalLedger: GeneralLedger[];
  generalLedgerLoading: boolean;
  generalLedgerError: string;
  generalLedgerPageNo: number;
  generalLedgerPageSize: number;
  generalLedgerTotalPages: number;
  generalLedgerFromDate: string;
  generalLedgerToDate: string;
  // Detailed General Ledger
  detailedGeneralLedger: DetailedGeneralLedger[];
  detailedGeneralLedgerLoading: boolean;
  detailedGeneralLedgerError: string;
  detailedGeneralLedgerPageNo: number;
  detailedGeneralLedgerPageSize: number;
  detailedGeneralLedgerTotalPages: number;
  detailedGeneralLedgerFromDate: string;
  detailedGeneralLedgerToDate: string;
  // Journal Report
  journalReport: JournalReport[];
  journalReportLoading: boolean;
  journalReportError: string;
  journalReportPageNo: number;
  journalReportPageSize: number;
  journalReportTotalPages: number;
  journalReportFromDate: string;
  journalReportToDate: string;
  // Trial Balance
  trialBalance: TrialBalance[];
  trialBalanceLoading: boolean;
  trialBalanceError: string;
  trialBalancePageNo: number;
  trialBalancePageSize: number;
  trialBalanceTotalPages: number;
  trialBalanceFromDate: string;
  trialBalanceToDate: string;
  // Timesheet Profitability Summary
  timesheetProfitabilitySummary: TimesheetProfitabilitySummary[];
  timesheetProfitabilitySummaryLoading: boolean;
  timesheetProfitabilitySummaryError: string;
  timesheetProfitabilitySummaryPageNo: number;
  timesheetProfitabilitySummaryPageSize: number;
  timesheetProfitabilitySummaryTotalPages: number;
  timesheetProfitabilitySummaryFromDate: string;
  timesheetProfitabilitySummaryToDate: string;
  // Project Summary
  projectSummary: ProjectSummary[];
  projectSummaryLoading: boolean;
  projectSummaryError: string;
  projectSummaryPageNo: number;
  projectSummaryPageSize: number;
  projectSummaryTotalPages: number;
  projectSummaryFromDate: string;
  projectSummaryToDate: string;
  // Project Details
  projectDetails: ProjectDetails[];
  projectDetailsLoading: boolean;
  projectDetailsError: string;
  projectDetailsPageNo: number;
  projectDetailsPageSize: number;
  projectDetailsTotalPages: number;
  projectDetailsFromDate: string;
  projectDetailsToDate: string;
  // Project Cost Summary
  projectCostSummary: ProjectCostSummary[];
  projectCostSummaryLoading: boolean;
  projectCostSummaryError: string;
  projectCostSummaryPageNo: number;
  projectCostSummaryPageSize: number;
  projectCostSummaryTotalPages: number;
  projectCostSummaryFromDate: string;
  projectCostSummaryToDate: string;
  // Project Revenue Summary
  projectRevenueSummary: ProjectRevenueSummary[];
  projectRevenueSummaryLoading: boolean;
  projectRevenueSummaryError: string;
  projectRevenueSummaryPageNo: number;
  projectRevenueSummaryPageSize: number;
  projectRevenueSummaryTotalPages: number;
  projectRevenueSummaryFromDate: string;
  projectRevenueSummaryToDate: string;
  // Projects Performance Summary
  projectsPerformanceSummary: ProjectsPerformanceSummary[];
  projectsPerformanceSummaryLoading: boolean;
  projectsPerformanceSummaryError: string;
  projectsPerformanceSummaryPageNo: number;
  projectsPerformanceSummaryPageSize: number;
  projectsPerformanceSummaryTotalPages: number;
  projectsPerformanceSummaryFromDate: string;
  projectsPerformanceSummaryToDate: string;
}

// const getFirstDateOfYear = () => {
//   const year = new Date().getFullYear(); // Get the year of the provided date
//   const firstDateOfYear = new Date(year, 0, 1); // Create a new date object with the first day of the year
//
//   return firstDateOfYear;
// };

const returnFirstDateOfMonth = () => {
  const date = new Date();
  return new Date(date.getFullYear(), date.getMonth(), 1);
};

const returnLastDateOfMonth = () => {
  const date = new Date();
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};

const initialState: Index = {
  projectId: "",
  // Customer Balance Sheet
  customerBalance: [],
  customerBalanceLoading: false,
  customerBalanceError: "",
  customerBalancePageNo: 1,
  customerBalancePageSize: 10,
  customerBalanceTotalPages: 0,
  customerBalanceFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  customerBalanceToDate: returnLastDateOfMonth().toLocaleDateString(),
  //   Payments Recieved
  paymentsRecieved: [],
  paymentsRecievedLoading: false,
  paymentsRecievedError: "",
  paymentsRecievedPageNo: 1,
  paymentsRecievedPageSize: 10,
  paymentsRecievedTotalPages: 0,
  paymentsRecievedFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  paymentsRecievedToDate: returnLastDateOfMonth().toLocaleDateString(),
  //   Sales
  sales: [],
  salesLoading: false,
  salesError: "",
  salesPageNo: 1,
  salesPageSize: 10,
  salesTotalPages: 0,
  salesFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  salesToDate: returnLastDateOfMonth().toLocaleDateString(),
  //   Credit Note Details
  creditNoteDetails: [],
  creditNoteDetailsLoading: false,
  creditNoteDetailsError: "",
  creditNoteDetailsPageNo: 1,
  creditNoteDetailsPageSize: 10,
  creditNoteDetailsTotalPages: 0,
  creditNoteDetailsFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  creditNoteDetailsToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Invoice Details
  invoiceDetails: [],
  invoiceDetailsLoading: false,
  invoiceDetailsError: "",
  invoiceDetailsPageNo: 1,
  invoiceDetailsPageSize: 10,
  invoiceDetailsTotalPages: 0,
  invoiceDetailsFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  invoiceDetailsToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Customer Balance Summary
  customerBalanceSummary: [],
  customerBalanceSummaryLoading: false,
  customerBalanceSummaryError: "",
  customerBalanceSummaryPageNo: 1,
  customerBalanceSummaryPageSize: 10,
  customerBalanceSummaryTotalPages: 0,
  customerBalanceSummaryFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  customerBalanceSummaryToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Payable Details
  payableDetails: [],
  payableDetailsLoading: false,
  payableDetailsError: "",
  payableDetailsPageNo: 1,
  payableDetailsPageSize: 10,
  payableDetailsTotalPages: 0,
  payableDetailsFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  payableDetailsToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Payable Summary
  payableSummary: [],
  payableSummaryLoading: false,
  payableSummaryError: "",
  payableSummaryPageNo: 1,
  payableSummaryPageSize: 10,
  payableSummaryTotalPages: 0,
  payableSummaryFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  payableSummaryToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Receivable Details
  receivableDetails: [],
  receivableDetailsLoading: false,
  receivableDetailsError: "",
  receivableDetailsPageNo: 1,
  receivableDetailsPageSize: 10,
  receivableDetailsTotalPages: 0,
  receivableDetailsFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  receivableDetailsToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Receivable Summary
  receivableSummary: [],
  receivableSummaryLoading: false,
  receivableSummaryError: "",
  receivableSummaryPageNo: 1,
  receivableSummaryPageSize: 10,
  receivableSummaryTotalPages: 0,
  receivableSummaryFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  receivableSummaryToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Expense Details
  expenseDetails: [],
  expenseDetailsLoading: false,
  expenseDetailsError: "",
  expenseDetailsPageNo: 1,
  expenseDetailsPageSize: 10,
  expenseDetailsTotalPages: 0,
  expenseDetailsFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  expenseDetailsToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Expenses By Project
  expensesByProject: [],
  expensesByProjectLoading: false,
  expensesByProjectError: "",
  expensesByProjectPageNo: 1,
  expensesByProjectPageSize: 10,
  expensesByProjectTotalPages: 0,
  expensesByProjectFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  expensesByProjectToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Expense By Category
  expenseByCategory: [],
  expenseByCategoryLoading: false,
  expenseByCategoryError: "",
  expenseByCategoryPageNo: 1,
  expenseByCategoryPageSize: 10,
  expenseByCategoryTotalPages: 0,
  expenseByCategoryFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  expenseByCategoryToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Vendor Balances
  vendorBalances: [],
  vendorBalancesLoading: false,
  vendorBalancesError: "",
  vendorBalancesPageNo: 1,
  vendorBalancesPageSize: 10,
  vendorBalancesTotalPages: 0,
  vendorBalancesFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  vendorBalancesToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Vendor Balances Summary
  vendorBalancesSummary: [],
  vendorBalancesSummaryLoading: false,
  vendorBalancesSummaryError: "",
  vendorBalancesSummaryPageNo: 1,
  vendorBalancesSummaryPageSize: 10,
  vendorBalancesSummaryTotalPages: 0,
  vendorBalancesSummaryFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  vendorBalancesSummaryToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Time To Get Paid
  timeToGetPaid: [],
  timeToGetPaidLoading: false,
  timeToGetPaidError: "",
  timeToGetPaidPageNo: 1,
  timeToGetPaidPageSize: 10,
  timeToGetPaidTotalPages: 0,
  timeToGetPaidFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  timeToGetPaidToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Purchase By Item
  purchaseByItem: [],
  purchaseByItemLoading: false,
  purchaseByItemError: "",
  purchaseByItemPageNo: 1,
  purchaseByItemPageSize: 10,
  purchaseByItemTotalPages: 0,
  purchaseByItemFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  purchaseByItemToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Bill Details
  billDetails: [],
  billDetailsLoading: false,
  billDetailsError: "",
  billDetailsPageNo: 1,
  billDetailsPageSize: 10,
  billDetailsTotalPages: 0,
  billDetailsFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  billDetailsToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Bill Payments Made
  billPaymentsMade: [],
  billPaymentsMadeLoading: false,
  billPaymentsMadeError: "",
  billPaymentsMadePageNo: 1,
  billPaymentsMadePageSize: 10,
  billPaymentsMadeTotalPages: 0,
  billPaymentsMadeFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  billPaymentsMadeToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Vendor Credit Details
  vendorCreditDetails: [],
  vendorCreditDetailsLoading: false,
  vendorCreditDetailsError: "",
  vendorCreditDetailsPageNo: 1,
  vendorCreditDetailsPageSize: 10,
  vendorCreditDetailsTotalPages: 0,
  vendorCreditDetailsFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  vendorCreditDetailsToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Purchase By Vendor
  purchaseByVendor: [],
  purchaseByVendorLoading: false,
  purchaseByVendorError: "",
  purchaseByVendorPageNo: 1,
  purchaseByVendorPageSize: 10,
  purchaseByVendorTotalPages: 0,
  purchaseByVendorFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  purchaseByVendorToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Billable Amount
  billableAmount: [],
  billableAmountLoading: false,
  billableAmountError: "",
  billableAmountPageNo: 1,
  billableAmountPageSize: 10,
  billableAmountTotalPages: 0,
  billableAmountFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  billableAmountToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Expenses By Employees
  expensesByEmployees: [],
  expensesByEmployeesLoading: false,
  expensesByEmployeesError: "",
  expensesByEmployeesPageNo: 1,
  expensesByEmployeesPageSize: 10,
  expensesByEmployeesTotalPages: 0,
  expensesByEmployeesFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  expensesByEmployeesToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Expenses By Client
  expensesByClient: [],
  expensesByClientLoading: false,
  expensesByClientError: "",
  expensesByClientPageNo: 1,
  expensesByClientPageSize: 10,
  expensesByClientTotalPages: 0,
  expensesByClientFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  expensesByClientToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Account Transactions
  accountTransactions: [],
  accountTransactionsLoading: false,
  accountTransactionsError: "",
  accountTransactionsPageNo: 1,
  accountTransactionsPageSize: 10,
  accountTransactionsTotalPages: 0,
  accountTransactionsFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  accountTransactionsToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Account Type Summary
  accountTypeSummary: [],
  accountTypeSummaryLoading: false,
  accountTypeSummaryError: "",
  accountTypeSummaryPageNo: 1,
  accountTypeSummaryPageSize: 10,
  accountTypeSummaryTotalPages: 0,
  accountTypeSummaryFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  accountTypeSummaryToDate: returnLastDateOfMonth().toLocaleDateString(),
  // General Ledger
  generalLedger: [],
  generalLedgerLoading: false,
  generalLedgerError: "",
  generalLedgerPageNo: 1,
  generalLedgerPageSize: 10,
  generalLedgerTotalPages: 0,
  generalLedgerFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  generalLedgerToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Detailed General Ledger
  detailedGeneralLedger: [],
  detailedGeneralLedgerLoading: false,
  detailedGeneralLedgerError: "",
  detailedGeneralLedgerPageNo: 1,
  detailedGeneralLedgerPageSize: 10,
  detailedGeneralLedgerTotalPages: 0,
  detailedGeneralLedgerFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  detailedGeneralLedgerToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Journal Report
  journalReport: [],
  journalReportLoading: false,
  journalReportError: "",
  journalReportPageNo: 1,
  journalReportPageSize: 10,
  journalReportTotalPages: 0,
  journalReportFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  journalReportToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Trial Balance
  trialBalance: [],
  trialBalanceLoading: false,
  trialBalanceError: "",
  trialBalancePageNo: 1,
  trialBalancePageSize: 10,
  trialBalanceTotalPages: 0,
  trialBalanceFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  trialBalanceToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Timesheet Profitability Summary
  timesheetProfitabilitySummary: [],
  timesheetProfitabilitySummaryLoading: false,
  timesheetProfitabilitySummaryError: "",
  timesheetProfitabilitySummaryPageNo: 1,
  timesheetProfitabilitySummaryPageSize: 10,
  timesheetProfitabilitySummaryTotalPages: 0,
  timesheetProfitabilitySummaryFromDate:
    returnFirstDateOfMonth().toLocaleDateString(),
  timesheetProfitabilitySummaryToDate:
    returnLastDateOfMonth().toLocaleDateString(),
  // Project Summary
  projectSummary: [],
  projectSummaryLoading: false,
  projectSummaryError: "",
  projectSummaryPageNo: 1,
  projectSummaryPageSize: 10,
  projectSummaryTotalPages: 0,
  projectSummaryFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  projectSummaryToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Project Details
  projectDetails: [],
  projectDetailsLoading: false,
  projectDetailsError: "",
  projectDetailsPageNo: 1,
  projectDetailsPageSize: 10,
  projectDetailsTotalPages: 0,
  projectDetailsFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  projectDetailsToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Project Cost Summary
  projectCostSummary: [],
  projectCostSummaryLoading: false,
  projectCostSummaryError: "",
  projectCostSummaryPageNo: 1,
  projectCostSummaryPageSize: 10,
  projectCostSummaryTotalPages: 0,
  projectCostSummaryFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  projectCostSummaryToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Project Revenue Summary
  projectRevenueSummary: [],
  projectRevenueSummaryLoading: false,
  projectRevenueSummaryError: "",
  projectRevenueSummaryPageNo: 1,
  projectRevenueSummaryPageSize: 10,
  projectRevenueSummaryTotalPages: 0,
  projectRevenueSummaryFromDate: returnFirstDateOfMonth().toLocaleDateString(),
  projectRevenueSummaryToDate: returnLastDateOfMonth().toLocaleDateString(),
  // Projects Performance Summary
  projectsPerformanceSummary: [],
  projectsPerformanceSummaryLoading: false,
  projectsPerformanceSummaryError: "",
  projectsPerformanceSummaryPageNo: 1,
  projectsPerformanceSummaryPageSize: 10,
  projectsPerformanceSummaryTotalPages: 0,
  projectsPerformanceSummaryFromDate:
    returnFirstDateOfMonth().toLocaleDateString(),
  projectsPerformanceSummaryToDate:
    returnLastDateOfMonth().toLocaleDateString(),
};

const reportsSlice = createSlice({
  name: "reports",
  initialState: initialState,
  reducers: {
    setProjectId: (state, action) => {
      state.projectId = action.payload;
    },
    // Customer Balance Sheet
    getCustomerBalanceRequest: (state) => {
      state.customerBalanceLoading = true;
      state.customerBalanceError = "";
    },
    getCustomerBalanceSuccess: (state, action) => {
      state.customerBalance = action.payload.data;
      state.customerBalanceLoading = false;
      state.customerBalanceError = "";
      state.customerBalanceTotalPages = action.payload.totalPages;
    },
    getCustomerBalanceFailure: (state, action) => {
      state.customerBalanceLoading = false;
      state.customerBalanceError = action.payload;
    },
    setCustomerBalancePageNo: (state, action) => {
      state.customerBalancePageNo = action.payload;
    },
    setCustomerBalancePageSize: (state, action) => {
      state.customerBalancePageSize = action.payload;
    },
    setCustomerBalanceFromDate: (state, action) => {
      state.customerBalanceFromDate = action.payload;
    },
    setCustomerBalanceToDate: (state, action) => {
      state.customerBalanceToDate = action.payload;
    },
    // Payments Recieved
    getPaymentsRecievedRequest: (state) => {
      state.paymentsRecievedLoading = true;
      state.paymentsRecievedError = "";
    },
    getPaymentsRecievedSuccess: (state, action) => {
      state.paymentsRecieved = action.payload.data;
      state.paymentsRecievedLoading = false;
      state.paymentsRecievedError = "";
      state.paymentsRecievedTotalPages = action.payload.totalPages;
    },
    getPaymentsRecievedFailure: (state, action) => {
      state.paymentsRecievedLoading = false;
      state.paymentsRecievedError = action.payload;
    },
    setPaymentsRecievedPageNo: (state, action) => {
      state.paymentsRecievedPageNo = action.payload;
    },
    setPaymentsRecievedPageSize: (state, action) => {
      state.paymentsRecievedPageSize = action.payload;
    },
    setPaymentsRecievedFromDate: (state, action) => {
      state.paymentsRecievedFromDate = action.payload;
    },
    setPaymentsRecievedToDate: (state, action) => {
      state.paymentsRecievedToDate = action.payload;
    },
    // Sales
    getSalesRequest: (state) => {
      state.salesLoading = true;
      state.salesError = "";
    },
    getSalesSuccess: (state, action) => {
      state.sales = action.payload.data;
      state.salesLoading = false;
      state.salesError = "";
      state.salesTotalPages = action.payload.totalPages;
    },
    getSalesFailure: (state, action) => {
      state.salesLoading = false;
      state.salesError = action.payload;
    },
    setSalesPageNo: (state, action) => {
      state.salesPageNo = action.payload;
    },
    setSalesPageSize: (state, action) => {
      state.salesPageSize = action.payload;
    },
    setSalesFromDate: (state, action) => {
      state.salesFromDate = action.payload;
    },
    setSalesToDate: (state, action) => {
      state.salesToDate = action.payload;
    },
    // Credit Note Details
    getCreditNoteDetailsRequest: (state) => {
      state.creditNoteDetailsLoading = true;
      state.creditNoteDetailsError = "";
    },
    getCreditNoteDetailsSuccess: (state, action) => {
      state.creditNoteDetails = action.payload.data;
      state.creditNoteDetailsLoading = false;
      state.creditNoteDetailsError = "";
      state.creditNoteDetailsTotalPages = action.payload.totalPages;
    },
    getCreditNoteDetailsFailure: (state, action) => {
      state.creditNoteDetailsLoading = false;
      state.creditNoteDetailsError = action.payload;
    },
    setCreditNoteDetailsPageNo: (state, action) => {
      state.creditNoteDetailsPageNo = action.payload;
    },
    setCreditNoteDetailsPageSize: (state, action) => {
      state.creditNoteDetailsPageSize = action.payload;
    },
    setCreditNoteDetailsFromDate: (state, action) => {
      state.creditNoteDetailsFromDate = action.payload;
    },
    setCreditNoteDetailsToDate: (state, action) => {
      state.creditNoteDetailsToDate = action.payload;
    },
    //   Invoice Details
    getInvoiceDetailsRequest: (state) => {
      state.invoiceDetailsLoading = true;
      state.invoiceDetailsError = "";
    },
    getInvoiceDetailsSuccess: (state, action) => {
      state.invoiceDetails = action.payload.data;
      state.invoiceDetailsLoading = false;
      state.invoiceDetailsError = "";
      state.invoiceDetailsTotalPages = action.payload.totalPages;
    },
    getInvoiceDetailsFailure: (state, action) => {
      state.invoiceDetailsLoading = false;
      state.invoiceDetailsError = action.payload;
    },
    setInvoiceDetailsPageNo: (state, action) => {
      state.invoiceDetailsPageNo = action.payload;
    },
    setInvoiceDetailsPageSize: (state, action) => {
      state.invoiceDetailsPageSize = action.payload;
    },
    setInvoiceDetailsFromDate: (state, action) => {
      state.invoiceDetailsFromDate = action.payload;
    },
    setInvoiceDetailsToDate: (state, action) => {
      state.invoiceDetailsToDate = action.payload;
    },
    // Customer Balance Summary
    getCustomerBalanceSummaryRequest: (state) => {
      state.customerBalanceSummaryLoading = true;
      state.customerBalanceSummaryError = "";
    },
    getCustomerBalanceSummarySuccess: (state, action) => {
      state.customerBalanceSummary = action.payload.data;
      state.customerBalanceSummaryLoading = false;
      state.customerBalanceSummaryError = "";
      state.customerBalanceSummaryTotalPages = action.payload.totalPages;
    },
    getCustomerBalanceSummaryFailure: (state, action) => {
      state.customerBalanceSummaryLoading = false;
      state.customerBalanceSummaryError = action.payload;
    },
    setCustomerBalanceSummaryPageNo: (state, action) => {
      state.customerBalanceSummaryPageNo = action.payload;
    },
    setCustomerBalanceSummaryPageSize: (state, action) => {
      state.customerBalanceSummaryPageSize = action.payload;
    },
    setCustomerBalanceSummaryFromDate: (state, action) => {
      state.customerBalanceSummaryFromDate = action.payload;
    },
    setCustomerBalanceSummaryToDate: (state, action) => {
      state.customerBalanceSummaryToDate = action.payload;
    },
    // Payable Details
    getPayableDetailsRequest: (state) => {
      state.payableDetailsLoading = true;
      state.payableDetailsError = "";
    },
    getPayableDetailsSuccess: (state, action) => {
      state.payableDetails = action.payload.data;
      state.payableDetailsLoading = false;
      state.payableDetailsError = "";
      state.payableDetailsTotalPages = action.payload.totalPages;
    },
    getPayableDetailsFailure: (state, action) => {
      state.payableDetailsLoading = false;
      state.payableDetailsError = action.payload;
    },
    setPayableDetailsPageNo: (state, action) => {
      state.payableDetailsPageNo = action.payload;
    },
    setPayableDetailsPageSize: (state, action) => {
      state.payableDetailsPageSize = action.payload;
    },
    setPayableDetailsFromDate: (state, action) => {
      state.payableDetailsFromDate = action.payload;
    },
    setPayableDetailsToDate: (state, action) => {
      state.payableDetailsToDate = action.payload;
    },
    // Payable Summary
    getPayableSummaryRequest: (state) => {
      state.payableSummaryLoading = true;
      state.payableSummaryError = "";
    },
    getPayableSummarySuccess: (state, action) => {
      state.payableSummary = action.payload.data;
      state.payableSummaryLoading = false;
      state.payableSummaryError = "";
      state.payableSummaryTotalPages = action.payload.totalPages;
    },
    getPayableSummaryFailure: (state, action) => {
      state.payableSummaryLoading = false;
      state.payableSummaryError = action.payload;
    },
    setPayableSummaryPageNo: (state, action) => {
      state.payableSummaryPageNo = action.payload;
    },
    setPayableSummaryPageSize: (state, action) => {
      state.payableSummaryPageSize = action.payload;
    },
    setPayableSummaryFromDate: (state, action) => {
      state.payableSummaryFromDate = action.payload;
    },
    setPayableSummaryToDate: (state, action) => {
      state.payableSummaryToDate = action.payload;
    },
    // Receivable Details
    getReceivableDetailsRequest: (state) => {
      state.receivableDetailsLoading = true;
      state.receivableDetailsError = "";
    },
    getReceivableDetailsSuccess: (state, action) => {
      state.receivableDetails = action.payload.data;
      state.receivableDetailsLoading = false;
      state.receivableDetailsError = "";
      state.receivableDetailsTotalPages = action.payload.totalPages;
    },
    getReceivableDetailsFailure: (state, action) => {
      state.receivableDetailsLoading = false;
      state.receivableDetailsError = action.payload;
    },
    setReceivableDetailsPageNo: (state, action) => {
      state.receivableDetailsPageNo = action.payload;
    },
    setReceivableDetailsPageSize: (state, action) => {
      state.receivableDetailsPageSize = action.payload;
    },
    setReceivableDetailsFromDate: (state, action) => {
      state.receivableDetailsFromDate = action.payload;
    },
    setReceivableDetailsToDate: (state, action) => {
      state.receivableDetailsToDate = action.payload;
    },
    // Receivable Summary
    getReceivableSummaryRequest: (state) => {
      state.receivableSummaryLoading = true;
      state.receivableSummaryError = "";
    },
    getReceivableSummarySuccess: (state, action) => {
      state.receivableSummary = action.payload.data;
      state.receivableSummaryLoading = false;
      state.receivableSummaryError = "";
      state.receivableSummaryTotalPages = action.payload.totalPages;
    },
    getReceivableSummaryFailure: (state, action) => {
      state.receivableSummaryLoading = false;
      state.receivableSummaryError = action.payload;
    },
    setReceivableSummaryPageNo: (state, action) => {
      state.receivableSummaryPageNo = action.payload;
    },
    setReceivableSummaryPageSize: (state, action) => {
      state.receivableSummaryPageSize = action.payload;
    },
    setReceivableSummaryFromDate: (state, action) => {
      state.receivableSummaryFromDate = action.payload;
    },
    setReceivableSummaryToDate: (state, action) => {
      state.receivableSummaryToDate = action.payload;
    },
    // Expense Details
    getExpenseDetailsRequest: (state) => {
      state.expenseDetailsLoading = true;
      state.expenseDetailsError = "";
    },
    getExpenseDetailsSuccess: (state, action) => {
      state.expenseDetails = action.payload.data;
      state.expenseDetailsLoading = false;
      state.expenseDetailsError = "";
      state.expenseDetailsTotalPages = action.payload.totalPages;
    },
    getExpenseDetailsFailure: (state, action) => {
      state.expenseDetailsLoading = false;
      state.expenseDetailsError = action.payload;
    },
    setExpenseDetailsPageNo: (state, action) => {
      state.expenseDetailsPageNo = action.payload;
    },
    setExpenseDetailsPageSize: (state, action) => {
      state.expenseDetailsPageSize = action.payload;
    },
    setExpenseDetailsFromDate: (state, action) => {
      state.expenseDetailsFromDate = action.payload;
    },
    setExpenseDetailsToDate: (state, action) => {
      state.expenseDetailsToDate = action.payload;
    },
    // Expenses By Project
    getExpensesByProjectRequest: (state) => {
      state.expensesByProjectLoading = true;
      state.expensesByProjectError = "";
    },
    getExpensesByProjectSuccess: (state, action) => {
      state.expensesByProject = action.payload.data;
      state.expensesByProjectLoading = false;
      state.expensesByProjectError = "";
      state.expensesByProjectTotalPages = action.payload.totalPages;
    },
    getExpensesByProjectFailure: (state, action) => {
      state.expensesByProjectLoading = false;
      state.expensesByProjectError = action.payload;
    },
    setExpensesByProjectPageNo: (state, action) => {
      state.expensesByProjectPageNo = action.payload;
    },
    setExpensesByProjectPageSize: (state, action) => {
      state.expensesByProjectPageSize = action.payload;
    },
    setExpensesByProjectFromDate: (state, action) => {
      state.expensesByProjectFromDate = action.payload;
    },
    setExpensesByProjectToDate: (state, action) => {
      state.expensesByProjectToDate = action.payload;
    },
    // Expense By Category
    getExpenseByCategoryRequest: (state) => {
      state.expenseByCategoryLoading = true;
      state.expenseByCategoryError = "";
    },
    getExpenseByCategorySuccess: (state, action) => {
      state.expenseByCategory = action.payload.data;
      state.expenseByCategoryLoading = false;
      state.expenseByCategoryError = "";
      state.expenseByCategoryTotalPages = action.payload.totalPages;
    },
    getExpenseByCategoryFailure: (state, action) => {
      state.expenseByCategoryLoading = false;
      state.expenseByCategoryError = action.payload;
    },
    setExpenseByCategoryPageNo: (state, action) => {
      state.expenseByCategoryPageNo = action.payload;
    },
    setExpenseByCategoryPageSize: (state, action) => {
      state.expenseByCategoryPageSize = action.payload;
    },
    setExpenseByCategoryFromDate: (state, action) => {
      state.expenseByCategoryFromDate = action.payload;
    },
    setExpenseByCategoryToDate: (state, action) => {
      state.expenseByCategoryToDate = action.payload;
    },
    // Vendor Balances
    getVendorBalancesRequest: (state) => {
      state.vendorBalancesLoading = true;
      state.vendorBalancesError = "";
    },
    getVendorBalancesSuccess: (state, action) => {
      state.vendorBalances = action.payload.data;
      state.vendorBalancesLoading = false;
      state.vendorBalancesError = "";
      state.vendorBalancesTotalPages = action.payload.totalPages;
    },
    getVendorBalancesFailure: (state, action) => {
      state.vendorBalancesLoading = false;
      state.vendorBalancesError = action.payload;
    },
    setVendorBalancesPageNo: (state, action) => {
      state.vendorBalancesPageNo = action.payload;
    },
    setVendorBalancesPageSize: (state, action) => {
      state.vendorBalancesPageSize = action.payload;
    },
    setVendorBalancesFromDate: (state, action) => {
      state.vendorBalancesFromDate = action.payload;
    },
    setVendorBalancesToDate: (state, action) => {
      state.vendorBalancesToDate = action.payload;
    },
    // Vendor Balances Summary
    getVendorBalancesSummaryRequest: (state) => {
      state.vendorBalancesSummaryLoading = true;
      state.vendorBalancesSummaryError = "";
    },
    getVendorBalancesSummarySuccess: (state, action) => {
      state.vendorBalancesSummary = action.payload.data;
      state.vendorBalancesSummaryLoading = false;
      state.vendorBalancesSummaryError = "";
      state.vendorBalancesSummaryTotalPages = action.payload.totalPages;
    },
    getVendorBalancesSummaryFailure: (state, action) => {
      state.vendorBalancesSummaryLoading = false;
      state.vendorBalancesSummaryError = action.payload;
    },
    setVendorBalancesSummaryPageNo: (state, action) => {
      state.vendorBalancesSummaryPageNo = action.payload;
    },
    setVendorBalancesSummaryPageSize: (state, action) => {
      state.vendorBalancesSummaryPageSize = action.payload;
    },
    setVendorBalancesSummaryFromDate: (state, action) => {
      state.vendorBalancesSummaryFromDate = action.payload;
    },
    setVendorBalancesSummaryToDate: (state, action) => {
      state.vendorBalancesSummaryToDate = action.payload;
    },
    // Time To Get Paid
    getTimeToGetPaidRequest: (state) => {
      state.timeToGetPaidLoading = true;
      state.timeToGetPaidError = "";
    },
    getTimeToGetPaidSuccess: (state, action) => {
      state.timeToGetPaid = action.payload.data;
      state.timeToGetPaidLoading = false;
      state.timeToGetPaidError = "";
      state.timeToGetPaidTotalPages = action.payload.totalPages;
    },
    getTimeToGetPaidFailure: (state, action) => {
      state.timeToGetPaidLoading = false;
      state.timeToGetPaidError = action.payload;
    },
    setTimeToGetPaidPageNo: (state, action) => {
      state.timeToGetPaidPageNo = action.payload;
    },
    setTimeToGetPaidPageSize: (state, action) => {
      state.timeToGetPaidPageSize = action.payload;
    },
    setTimeToGetPaidFromDate: (state, action) => {
      state.timeToGetPaidFromDate = action.payload;
    },
    setTimeToGetPaidToDate: (state, action) => {
      state.timeToGetPaidToDate = action.payload;
    },
    // Purchase By Item
    getPurchaseByItemRequest: (state) => {
      state.purchaseByItemLoading = true;
      state.purchaseByItemError = "";
    },
    getPurchaseByItemSuccess: (state, action) => {
      state.purchaseByItem = action.payload.data;
      state.purchaseByItemLoading = false;
      state.purchaseByItemError = "";
      state.purchaseByItemTotalPages = action.payload.totalPages;
    },
    getPurchaseByItemFailure: (state, action) => {
      state.purchaseByItemLoading = false;
      state.purchaseByItemError = action.payload;
    },
    setPurchaseByItemPageNo: (state, action) => {
      state.purchaseByItemPageNo = action.payload;
    },
    setPurchaseByItemPageSize: (state, action) => {
      state.purchaseByItemPageSize = action.payload;
    },
    setPurchaseByItemFromDate: (state, action) => {
      state.purchaseByItemFromDate = action.payload;
    },
    setPurchaseByItemToDate: (state, action) => {
      state.purchaseByItemToDate = action.payload;
    },
    // Bill Details
    getBillDetailsRequest: (state) => {
      state.billDetailsLoading = true;
      state.billDetailsError = "";
    },
    getBillDetailsSuccess: (state, action) => {
      state.billDetails = action.payload.data;
      state.billDetailsLoading = false;
      state.billDetailsError = "";
      state.billDetailsTotalPages = action.payload.totalPages;
    },
    getBillDetailsFailure: (state, action) => {
      state.billDetailsLoading = false;
      state.billDetailsError = action.payload;
    },
    setBillDetailsPageNo: (state, action) => {
      state.billDetailsPageNo = action.payload;
    },
    setBillDetailsPageSize: (state, action) => {
      state.billDetailsPageSize = action.payload;
    },
    setBillDetailsFromDate: (state, action) => {
      state.billDetailsFromDate = action.payload;
    },
    setBillDetailsToDate: (state, action) => {
      state.billDetailsToDate = action.payload;
    },
    // Bill Payments Made
    getBillPaymentsMadeRequest: (state) => {
      state.billPaymentsMadeLoading = true;
      state.billPaymentsMadeError = "";
    },
    getBillPaymentsMadeSuccess: (state, action) => {
      state.billPaymentsMade = action.payload.data;
      state.billPaymentsMadeLoading = false;
      state.billPaymentsMadeError = "";
      state.billPaymentsMadeTotalPages = action.payload.totalPages;
    },
    getBillPaymentsMadeFailure: (state, action) => {
      state.billPaymentsMadeLoading = false;
      state.billPaymentsMadeError = action.payload;
    },
    setBillPaymentsMadePageNo: (state, action) => {
      state.billPaymentsMadePageNo = action.payload;
    },
    setBillPaymentsMadePageSize: (state, action) => {
      state.billPaymentsMadePageSize = action.payload;
    },
    setBillPaymentsMadeFromDate: (state, action) => {
      state.billPaymentsMadeFromDate = action.payload;
    },
    setBillPaymentsMadeToDate: (state, action) => {
      state.billPaymentsMadeToDate = action.payload;
    },
    //   Vendor Credit Details
    getVendorCreditDetailsRequest: (state) => {
      state.vendorCreditDetailsLoading = true;
      state.vendorCreditDetailsError = "";
    },
    getVendorCreditDetailsSuccess: (state, action) => {
      state.vendorCreditDetails = action.payload.data;
      state.vendorCreditDetailsLoading = false;
      state.vendorCreditDetailsError = "";
      state.vendorCreditDetailsTotalPages = action.payload.totalPages;
    },
    getVendorCreditDetailsFailure: (state, action) => {
      state.vendorCreditDetailsLoading = false;
      state.vendorCreditDetailsError = action.payload;
    },
    setVendorCreditDetailsPageNo: (state, action) => {
      state.vendorCreditDetailsPageNo = action.payload;
    },
    setVendorCreditDetailsPageSize: (state, action) => {
      state.vendorCreditDetailsPageSize = action.payload;
    },
    setVendorCreditDetailsFromDate: (state, action) => {
      state.vendorCreditDetailsFromDate = action.payload;
    },
    setVendorCreditDetailsToDate: (state, action) => {
      state.vendorCreditDetailsToDate = action.payload;
    },
    // Purchase By Vendor
    getPurchaseByVendorRequest: (state) => {
      state.purchaseByVendorLoading = true;
      state.purchaseByVendorError = "";
    },
    getPurchaseByVendorSuccess: (state, action) => {
      state.purchaseByVendor = action.payload.data;
      state.purchaseByVendorLoading = false;
      state.purchaseByVendorError = "";
      state.purchaseByVendorTotalPages = action.payload.totalPages;
    },
    getPurchaseByVendorFailure: (state, action) => {
      state.purchaseByVendorLoading = false;
      state.purchaseByVendorError = action.payload;
    },
    setPurchaseByVendorPageNo: (state, action) => {
      state.purchaseByVendorPageNo = action.payload;
    },
    setPurchaseByVendorPageSize: (state, action) => {
      state.purchaseByVendorPageSize = action.payload;
    },
    setPurchaseByVendorFromDate: (state, action) => {
      state.purchaseByVendorFromDate = action.payload;
    },
    setPurchaseByVendorToDate: (state, action) => {
      state.purchaseByVendorToDate = action.payload;
    },
    // Billable Amount
    getBillableAmountRequest: (state) => {
      state.billableAmountLoading = true;
      state.billableAmountError = "";
    },
    getBillableAmountSuccess: (state, action) => {
      state.billableAmount = action.payload.data;
      state.billableAmountLoading = false;
      state.billableAmountError = "";
      state.billableAmountTotalPages = action.payload.totalPages;
    },
    getBillableAmountFailure: (state, action) => {
      state.billableAmountLoading = false;
      state.billableAmountError = action.payload;
    },
    setBillableAmountPageNo: (state, action) => {
      state.billableAmountPageNo = action.payload;
    },
    setBillableAmountPageSize: (state, action) => {
      state.billableAmountPageSize = action.payload;
    },
    setBillableAmountFromDate: (state, action) => {
      state.billableAmountFromDate = action.payload;
    },
    setBillableAmountToDate: (state, action) => {
      state.billableAmountToDate = action.payload;
    },
    // Expenses By Employees
    getExpensesByEmployeesRequest: (state) => {
      state.expensesByEmployeesLoading = true;
      state.expensesByEmployeesError = "";
    },
    getExpensesByEmployeesSuccess: (state, action) => {
      state.expensesByEmployees = action.payload.data;
      state.expensesByEmployeesLoading = false;
      state.expensesByEmployeesError = "";
      state.expensesByEmployeesTotalPages = action.payload.totalPages;
    },
    getExpensesByEmployeesFailure: (state, action) => {
      state.expensesByEmployeesLoading = false;
      state.expensesByEmployeesError = action.payload;
    },
    setExpensesByEmployeesPageNo: (state, action) => {
      state.expensesByEmployeesPageNo = action.payload;
    },
    setExpensesByEmployeesPageSize: (state, action) => {
      state.expensesByEmployeesPageSize = action.payload;
    },
    setExpensesByEmployeesFromDate: (state, action) => {
      state.expensesByEmployeesFromDate = action.payload;
    },
    setExpensesByEmployeesToDate: (state, action) => {
      state.expensesByEmployeesToDate = action.payload;
    },
    // Expenses By Client
    getExpensesByClientRequest: (state) => {
      state.expensesByClientLoading = true;
      state.expensesByClientError = "";
    },
    getExpensesByClientSuccess: (state, action) => {
      state.expensesByClient = action.payload.data;
      state.expensesByClientLoading = false;
      state.expensesByClientError = "";
      state.expensesByClientTotalPages = action.payload.totalPages;
    },
    getExpensesByClientFailure: (state, action) => {
      state.expensesByClientLoading = false;
      state.expensesByClientError = action.payload;
    },
    setExpensesByClientPageNo: (state, action) => {
      state.expensesByClientPageNo = action.payload;
    },
    setExpensesByClientPageSize: (state, action) => {
      state.expensesByClientPageSize = action.payload;
    },
    setExpensesByClientFromDate: (state, action) => {
      state.expensesByClientFromDate = action.payload;
    },
    setExpensesByClientToDate: (state, action) => {
      state.expensesByClientToDate = action.payload;
    },
    // Account Transactions
    getAccountTransactionsRequest: (state) => {
      state.accountTransactionsLoading = true;
      state.accountTransactionsError = "";
    },
    getAccountTransactionsSuccess: (state, action) => {
      state.accountTransactions = action.payload.data;
      state.accountTransactionsLoading = false;
      state.accountTransactionsError = "";
      state.accountTransactionsTotalPages = action.payload.totalPages;
    },
    getAccountTransactionsFailure: (state, action) => {
      state.accountTransactionsLoading = false;
      state.accountTransactionsError = action.payload;
    },
    setAccountTransactionsPageNo: (state, action) => {
      state.accountTransactionsPageNo = action.payload;
    },
    setAccountTransactionsPageSize: (state, action) => {
      state.accountTransactionsPageSize = action.payload;
    },
    setAccountTransactionsFromDate: (state, action) => {
      state.accountTransactionsFromDate = action.payload;
    },
    setAccountTransactionsToDate: (state, action) => {
      state.accountTransactionsToDate = action.payload;
    },
    // Account Type Summary
    getAccountTypeSummaryRequest: (state) => {
      state.accountTypeSummaryLoading = true;
      state.accountTypeSummaryError = "";
    },
    getAccountTypeSummarySuccess: (state, action) => {
      state.accountTypeSummary = action.payload.data;
      state.accountTypeSummaryLoading = false;
      state.accountTypeSummaryError = "";
      state.accountTypeSummaryTotalPages = action.payload.totalPages;
    },
    getAccountTypeSummaryFailure: (state, action) => {
      state.accountTypeSummaryLoading = false;
      state.accountTypeSummaryError = action.payload;
    },
    setAccountTypeSummaryPageNo: (state, action) => {
      state.accountTypeSummaryPageNo = action.payload;
    },
    setAccountTypeSummaryPageSize: (state, action) => {
      state.accountTypeSummaryPageSize = action.payload;
    },
    setAccountTypeSummaryFromDate: (state, action) => {
      state.accountTypeSummaryFromDate = action.payload;
    },
    setAccountTypeSummaryToDate: (state, action) => {
      state.accountTypeSummaryToDate = action.payload;
    },
    // General Ledger
    getGeneralLedgerRequest: (state) => {
      state.generalLedgerLoading = true;
      state.generalLedgerError = "";
    },
    getGeneralLedgerSuccess: (state, action) => {
      state.generalLedger = action.payload.data;
      state.generalLedgerLoading = false;
      state.generalLedgerError = "";
      state.generalLedgerTotalPages = action.payload.totalPages;
    },
    getGeneralLedgerFailure: (state, action) => {
      state.generalLedgerLoading = false;
      state.generalLedgerError = action.payload;
    },
    setGeneralLedgerPageNo: (state, action) => {
      state.generalLedgerPageNo = action.payload;
    },
    setGeneralLedgerPageSize: (state, action) => {
      state.generalLedgerPageSize = action.payload;
    },
    setGeneralLedgerFromDate: (state, action) => {
      state.generalLedgerFromDate = action.payload;
    },
    setGeneralLedgerToDate: (state, action) => {
      state.generalLedgerToDate = action.payload;
    },
    // Detailed General Ledger
    getDetailedGeneralLedgerRequest: (state) => {
      state.detailedGeneralLedgerLoading = true;
      state.detailedGeneralLedgerError = "";
    },
    getDetailedGeneralLedgerSuccess: (state, action) => {
      state.detailedGeneralLedger = action.payload.data;
      state.detailedGeneralLedgerLoading = false;
      state.detailedGeneralLedgerError = "";
      state.detailedGeneralLedgerTotalPages = action.payload.totalPages;
    },
    getDetailedGeneralLedgerFailure: (state, action) => {
      state.detailedGeneralLedgerLoading = false;
      state.detailedGeneralLedgerError = action.payload;
    },
    setDetailedGeneralLedgerPageNo: (state, action) => {
      state.detailedGeneralLedgerPageNo = action.payload;
    },
    setDetailedGeneralLedgerPageSize: (state, action) => {
      state.detailedGeneralLedgerPageSize = action.payload;
    },
    setDetailedGeneralLedgerFromDate: (state, action) => {
      state.detailedGeneralLedgerFromDate = action.payload;
    },
    setDetailedGeneralLedgerToDate: (state, action) => {
      state.detailedGeneralLedgerToDate = action.payload;
    },
    // Journal Report
    getJournalReportRequest: (state) => {
      state.journalReportLoading = true;
      state.journalReportError = "";
    },
    getJournalReportSuccess: (state, action) => {
      state.journalReport = action.payload.data;
      state.journalReportLoading = false;
      state.journalReportError = "";
      state.journalReportTotalPages = action.payload.totalPages;
    },
    getJournalReportFailure: (state, action) => {
      state.journalReportLoading = false;
      state.journalReportError = action.payload;
    },
    setJournalReportPageNo: (state, action) => {
      state.journalReportPageNo = action.payload;
    },
    setJournalReportPageSize: (state, action) => {
      state.journalReportPageSize = action.payload;
    },
    setJournalReportFromDate: (state, action) => {
      state.journalReportFromDate = action.payload;
    },
    setJournalReportToDate: (state, action) => {
      state.journalReportToDate = action.payload;
    },
    // Trial Balance
    getTrialBalanceRequest: (state) => {
      state.trialBalanceLoading = true;
      state.trialBalanceError = "";
    },
    getTrialBalanceSuccess: (state, action) => {
      state.trialBalance = action.payload.data;
      state.trialBalanceLoading = false;
      state.trialBalanceError = "";
      state.trialBalanceTotalPages = action.payload.totalPages;
    },
    getTrialBalanceFailure: (state, action) => {
      state.trialBalanceLoading = false;
      state.trialBalanceError = action.payload;
    },
    setTrialBalancePageNo: (state, action) => {
      state.trialBalancePageNo = action.payload;
    },
    setTrialBalancePageSize: (state, action) => {
      state.trialBalancePageSize = action.payload;
    },
    setTrialBalanceFromDate: (state, action) => {
      state.trialBalanceFromDate = action.payload;
    },
    setTrialBalanceToDate: (state, action) => {
      state.trialBalanceToDate = action.payload;
    },
    // Timesheet Profitability Summary
    getTimesheetProfitabilitySummaryRequest: (state) => {
      state.timesheetProfitabilitySummaryLoading = true;
      state.timesheetProfitabilitySummaryError = "";
    },
    getTimesheetProfitabilitySummarySuccess: (state, action) => {
      state.timesheetProfitabilitySummary = action.payload.data;
      state.timesheetProfitabilitySummaryLoading = false;
      state.timesheetProfitabilitySummaryError = "";
      state.timesheetProfitabilitySummaryTotalPages = action.payload.totalPages;
    },
    getTimesheetProfitabilitySummaryFailure: (state, action) => {
      state.timesheetProfitabilitySummaryLoading = false;
      state.timesheetProfitabilitySummaryError = action.payload;
    },
    setTimesheetProfitabilitySummaryPageNo: (state, action) => {
      state.timesheetProfitabilitySummaryPageNo = action.payload;
    },
    setTimesheetProfitabilitySummaryPageSize: (state, action) => {
      state.timesheetProfitabilitySummaryPageSize = action.payload;
    },
    setTimesheetProfitabilitySummaryFromDate: (state, action) => {
      state.timesheetProfitabilitySummaryFromDate = action.payload;
    },
    setTimesheetProfitabilitySummaryToDate: (state, action) => {
      state.timesheetProfitabilitySummaryToDate = action.payload;
    },
    // Project Summary
    getProjectSummaryRequest: (state) => {
      state.projectSummaryLoading = true;
      state.projectSummaryError = "";
    },
    getProjectSummarySuccess: (state, action) => {
      state.projectSummary = action.payload.data;
      state.projectSummaryLoading = false;
      state.projectSummaryError = "";
      state.projectSummaryTotalPages = action.payload.totalPages;
    },
    getProjectSummaryFailure: (state, action) => {
      state.projectSummaryLoading = false;
      state.projectSummaryError = action.payload;
    },
    setProjectSummaryPageNo: (state, action) => {
      state.projectSummaryPageNo = action.payload;
    },
    setProjectSummaryPageSize: (state, action) => {
      state.projectSummaryPageSize = action.payload;
    },
    setProjectSummaryFromDate: (state, action) => {
      state.projectSummaryFromDate = action.payload;
    },
    setProjectSummaryToDate: (state, action) => {
      state.projectSummaryToDate = action.payload;
    },
    // Project Details
    getProjectDetailsRequest: (state) => {
      state.projectDetailsLoading = true;
      state.projectDetailsError = "";
    },
    getProjectDetailsSuccess: (state, action) => {
      state.projectDetails = action.payload.data;
      state.projectDetailsLoading = false;
      state.projectDetailsError = "";
      state.projectDetailsTotalPages = action.payload.totalPages;
    },
    getProjectDetailsFailure: (state, action) => {
      state.projectDetailsLoading = false;
      state.projectDetailsError = action.payload;
    },
    setProjectDetailsPageNo: (state, action) => {
      state.projectDetailsPageNo = action.payload;
    },
    setProjectDetailsPageSize: (state, action) => {
      state.projectDetailsPageSize = action.payload;
    },
    setProjectDetailsFromDate: (state, action) => {
      state.projectDetailsFromDate = action.payload;
    },
    setProjectDetailsToDate: (state, action) => {
      state.projectDetailsToDate = action.payload;
    },
    // Project Cost Summary
    getProjectCostSummaryRequest: (state) => {
      state.projectCostSummaryLoading = true;
      state.projectCostSummaryError = "";
    },
    getProjectCostSummarySuccess: (state, action) => {
      state.projectCostSummary = action.payload.data;
      state.projectCostSummaryLoading = false;
      state.projectCostSummaryError = "";
      state.projectCostSummaryTotalPages = action.payload.totalPages;
    },
    getProjectCostSummaryFailure: (state, action) => {
      state.projectCostSummaryLoading = false;
      state.projectCostSummaryError = action.payload;
    },
    setProjectCostSummaryPageNo: (state, action) => {
      state.projectCostSummaryPageNo = action.payload;
    },
    setProjectCostSummaryPageSize: (state, action) => {
      state.projectCostSummaryPageSize = action.payload;
    },
    setProjectCostSummaryFromDate: (state, action) => {
      state.projectCostSummaryFromDate = action.payload;
    },
    setProjectCostSummaryToDate: (state, action) => {
      state.projectCostSummaryToDate = action.payload;
    },
    // Project Revenue Summary
    getProjectRevenueSummaryRequest: (state) => {
      state.projectRevenueSummaryLoading = true;
      state.projectRevenueSummaryError = "";
    },
    getProjectRevenueSummarySuccess: (state, action) => {
      state.projectRevenueSummary = action.payload.data;
      state.projectRevenueSummaryLoading = false;
      state.projectRevenueSummaryError = "";
      state.projectRevenueSummaryTotalPages = action.payload.totalPages;
    },
    getProjectRevenueSummaryFailure: (state, action) => {
      state.projectRevenueSummaryLoading = false;
      state.projectRevenueSummaryError = action.payload;
    },
    setProjectRevenueSummaryPageNo: (state, action) => {
      state.projectRevenueSummaryPageNo = action.payload;
    },
    setProjectRevenueSummaryPageSize: (state, action) => {
      state.projectRevenueSummaryPageSize = action.payload;
    },
    setProjectRevenueSummaryFromDate: (state, action) => {
      state.projectRevenueSummaryFromDate = action.payload;
    },
    setProjectRevenueSummaryToDate: (state, action) => {
      state.projectRevenueSummaryToDate = action.payload;
    },
    // Projects Performance Summary
    getProjectsPerformanceSummaryRequest: (state) => {
      state.projectsPerformanceSummaryLoading = true;
      state.projectsPerformanceSummaryError = "";
    },
    getProjectsPerformanceSummarySuccess: (state, action) => {
      state.projectsPerformanceSummary = action.payload.data;
      state.projectsPerformanceSummaryLoading = false;
      state.projectsPerformanceSummaryError = "";
      state.projectsPerformanceSummaryTotalPages = action.payload.totalPages;
    },
    getProjectsPerformanceSummaryFailure: (state, action) => {
      state.projectsPerformanceSummaryLoading = false;
      state.projectsPerformanceSummaryError = action.payload;
    },
    setProjectsPerformanceSummaryPageNo: (state, action) => {
      state.projectsPerformanceSummaryPageNo = action.payload;
    },
    setProjectsPerformanceSummaryPageSize: (state, action) => {
      state.projectsPerformanceSummaryPageSize = action.payload;
    },
    setProjectsPerformanceSummaryFromDate: (state, action) => {
      state.projectsPerformanceSummaryFromDate = action.payload;
    },
    setProjectsPerformanceSummaryToDate: (state, action) => {
      state.projectsPerformanceSummaryToDate = action.payload;
    },
  },
});

export const {
  setProjectId,
  // Customer Balance Sheet
  getCustomerBalanceRequest,
  getCustomerBalanceSuccess,
  getCustomerBalanceFailure,
  setCustomerBalancePageNo,
  setCustomerBalancePageSize,
  setCustomerBalanceFromDate,
  setCustomerBalanceToDate,
  // Payments Recieved
  getPaymentsRecievedRequest,
  getPaymentsRecievedSuccess,
  getPaymentsRecievedFailure,
  setPaymentsRecievedPageNo,
  setPaymentsRecievedPageSize,
  setPaymentsRecievedFromDate,
  setPaymentsRecievedToDate,
  // Sales
  getSalesRequest,
  getSalesSuccess,
  getSalesFailure,
  setSalesPageNo,
  setSalesPageSize,
  setSalesFromDate,
  setSalesToDate,
  // Credit Note Details
  getCreditNoteDetailsRequest,
  getCreditNoteDetailsSuccess,
  getCreditNoteDetailsFailure,
  setCreditNoteDetailsPageNo,
  setCreditNoteDetailsPageSize,
  setCreditNoteDetailsFromDate,
  setCreditNoteDetailsToDate,
  // Invoice Details
  getInvoiceDetailsRequest,
  getInvoiceDetailsSuccess,
  getInvoiceDetailsFailure,
  setInvoiceDetailsPageNo,
  setInvoiceDetailsPageSize,
  setInvoiceDetailsFromDate,
  setInvoiceDetailsToDate,
  // Customer Balance Summary
  getCustomerBalanceSummaryRequest,
  getCustomerBalanceSummarySuccess,
  getCustomerBalanceSummaryFailure,
  setCustomerBalanceSummaryPageNo,
  setCustomerBalanceSummaryPageSize,
  setCustomerBalanceSummaryFromDate,
  setCustomerBalanceSummaryToDate,
  // Payable Details
  getPayableDetailsRequest,
  getPayableDetailsSuccess,
  getPayableDetailsFailure,
  setPayableDetailsPageNo,
  setPayableDetailsPageSize,
  setPayableDetailsFromDate,
  setPayableDetailsToDate,
  // Payable Summary
  getPayableSummaryRequest,
  getPayableSummarySuccess,
  getPayableSummaryFailure,
  setPayableSummaryPageNo,
  setPayableSummaryPageSize,
  setPayableSummaryFromDate,
  setPayableSummaryToDate,
  // Receivable Details
  getReceivableDetailsRequest,
  getReceivableDetailsSuccess,
  getReceivableDetailsFailure,
  setReceivableDetailsPageNo,
  setReceivableDetailsPageSize,
  setReceivableDetailsFromDate,
  setReceivableDetailsToDate,
  // Receivable Summary
  getReceivableSummaryRequest,
  getReceivableSummarySuccess,
  getReceivableSummaryFailure,
  setReceivableSummaryPageNo,
  setReceivableSummaryPageSize,
  setReceivableSummaryFromDate,
  setReceivableSummaryToDate,
  // Expense Details
  getExpenseDetailsRequest,
  getExpenseDetailsSuccess,
  getExpenseDetailsFailure,
  setExpenseDetailsPageNo,
  setExpenseDetailsPageSize,
  setExpenseDetailsFromDate,
  setExpenseDetailsToDate,
  // Expenses By Project
  getExpensesByProjectRequest,
  getExpensesByProjectSuccess,
  getExpensesByProjectFailure,
  setExpensesByProjectPageNo,
  setExpensesByProjectPageSize,
  setExpensesByProjectFromDate,
  setExpensesByProjectToDate,
  // Expense By Category
  getExpenseByCategoryRequest,
  getExpenseByCategorySuccess,
  getExpenseByCategoryFailure,
  setExpenseByCategoryPageNo,
  setExpenseByCategoryPageSize,
  setExpenseByCategoryFromDate,
  setExpenseByCategoryToDate,
  // Vendor Balances
  getVendorBalancesRequest,
  getVendorBalancesSuccess,
  getVendorBalancesFailure,
  setVendorBalancesPageNo,
  setVendorBalancesPageSize,
  setVendorBalancesFromDate,
  setVendorBalancesToDate,
  // Vendor Balances Summary
  getVendorBalancesSummaryRequest,
  getVendorBalancesSummarySuccess,
  getVendorBalancesSummaryFailure,
  setVendorBalancesSummaryPageNo,
  setVendorBalancesSummaryPageSize,
  setVendorBalancesSummaryFromDate,
  setVendorBalancesSummaryToDate,
  // Time To Get Paid
  getTimeToGetPaidRequest,
  getTimeToGetPaidSuccess,
  getTimeToGetPaidFailure,
  setTimeToGetPaidPageNo,
  setTimeToGetPaidPageSize,
  setTimeToGetPaidFromDate,
  setTimeToGetPaidToDate,
  // Purchase By Item
  getPurchaseByItemRequest,
  getPurchaseByItemSuccess,
  getPurchaseByItemFailure,
  setPurchaseByItemPageNo,
  setPurchaseByItemPageSize,
  setPurchaseByItemFromDate,
  setPurchaseByItemToDate,
  // Bill Details
  getBillDetailsRequest,
  getBillDetailsSuccess,
  getBillDetailsFailure,
  setBillDetailsPageNo,
  setBillDetailsPageSize,
  setBillDetailsFromDate,
  setBillDetailsToDate,
  // Bill Payments Made
  getBillPaymentsMadeRequest,
  getBillPaymentsMadeSuccess,
  getBillPaymentsMadeFailure,
  setBillPaymentsMadePageNo,
  setBillPaymentsMadePageSize,
  setBillPaymentsMadeFromDate,
  setBillPaymentsMadeToDate,
  // Vendor Credit Details
  getVendorCreditDetailsRequest,
  getVendorCreditDetailsSuccess,
  getVendorCreditDetailsFailure,
  setVendorCreditDetailsPageNo,
  setVendorCreditDetailsPageSize,
  setVendorCreditDetailsFromDate,
  setVendorCreditDetailsToDate,
  // Purchase By Vendor
  getPurchaseByVendorRequest,
  getPurchaseByVendorSuccess,
  getPurchaseByVendorFailure,
  setPurchaseByVendorPageNo,
  setPurchaseByVendorPageSize,
  setPurchaseByVendorFromDate,
  setPurchaseByVendorToDate,
  // Billable Amount
  getBillableAmountRequest,
  getBillableAmountSuccess,
  getBillableAmountFailure,
  setBillableAmountPageNo,
  setBillableAmountPageSize,
  setBillableAmountFromDate,
  setBillableAmountToDate,
  // Expenses By Employees
  getExpensesByEmployeesRequest,
  getExpensesByEmployeesSuccess,
  getExpensesByEmployeesFailure,
  setExpensesByEmployeesPageNo,
  setExpensesByEmployeesPageSize,
  setExpensesByEmployeesFromDate,
  setExpensesByEmployeesToDate,
  // Expenses By Client
  getExpensesByClientRequest,
  getExpensesByClientSuccess,
  getExpensesByClientFailure,
  setExpensesByClientPageNo,
  setExpensesByClientPageSize,
  setExpensesByClientFromDate,
  setExpensesByClientToDate,
  // Account Transactions
  getAccountTransactionsRequest,
  getAccountTransactionsSuccess,
  getAccountTransactionsFailure,
  setAccountTransactionsPageNo,
  setAccountTransactionsPageSize,
  setAccountTransactionsFromDate,
  setAccountTransactionsToDate,
  // Account Type Summary
  getAccountTypeSummaryRequest,
  getAccountTypeSummarySuccess,
  getAccountTypeSummaryFailure,
  setAccountTypeSummaryPageNo,
  setAccountTypeSummaryPageSize,
  setAccountTypeSummaryFromDate,
  setAccountTypeSummaryToDate,
  // General Ledger
  getGeneralLedgerRequest,
  getGeneralLedgerSuccess,
  getGeneralLedgerFailure,
  setGeneralLedgerPageNo,
  setGeneralLedgerPageSize,
  setGeneralLedgerFromDate,
  setGeneralLedgerToDate,
  // Detailed General Ledger
  getDetailedGeneralLedgerRequest,
  getDetailedGeneralLedgerSuccess,
  getDetailedGeneralLedgerFailure,
  setDetailedGeneralLedgerPageNo,
  setDetailedGeneralLedgerPageSize,
  setDetailedGeneralLedgerFromDate,
  setDetailedGeneralLedgerToDate,
  // Journal Report
  getJournalReportRequest,
  getJournalReportSuccess,
  getJournalReportFailure,
  setJournalReportPageNo,
  setJournalReportPageSize,
  setJournalReportFromDate,
  setJournalReportToDate,
  // Trial Balance
  getTrialBalanceRequest,
  getTrialBalanceSuccess,
  getTrialBalanceFailure,
  setTrialBalancePageNo,
  setTrialBalancePageSize,
  setTrialBalanceFromDate,
  setTrialBalanceToDate,
  // Timesheet Profitability Summary
  getTimesheetProfitabilitySummaryRequest,
  getTimesheetProfitabilitySummarySuccess,
  getTimesheetProfitabilitySummaryFailure,
  setTimesheetProfitabilitySummaryPageNo,
  setTimesheetProfitabilitySummaryPageSize,
  setTimesheetProfitabilitySummaryFromDate,
  setTimesheetProfitabilitySummaryToDate,
  // Project Summary
  getProjectSummaryRequest,
  getProjectSummarySuccess,
  getProjectSummaryFailure,
  setProjectSummaryPageNo,
  setProjectSummaryPageSize,
  setProjectSummaryFromDate,
  setProjectSummaryToDate,
  // Project Details
  getProjectDetailsRequest,
  getProjectDetailsSuccess,
  getProjectDetailsFailure,
  setProjectDetailsPageNo,
  setProjectDetailsPageSize,
  setProjectDetailsFromDate,
  setProjectDetailsToDate,
  // Project Cost Summary
  getProjectCostSummaryRequest,
  getProjectCostSummarySuccess,
  getProjectCostSummaryFailure,
  setProjectCostSummaryPageNo,
  setProjectCostSummaryPageSize,
  setProjectCostSummaryFromDate,
  setProjectCostSummaryToDate,
  // Project Revenue Summary
  getProjectRevenueSummaryRequest,
  getProjectRevenueSummarySuccess,
  getProjectRevenueSummaryFailure,
  setProjectRevenueSummaryPageNo,
  setProjectRevenueSummaryPageSize,
  setProjectRevenueSummaryFromDate,
  setProjectRevenueSummaryToDate,
  // Projects Performance Summary
  getProjectsPerformanceSummaryRequest,
  getProjectsPerformanceSummarySuccess,
  getProjectsPerformanceSummaryFailure,
  setProjectsPerformanceSummaryPageNo,
  setProjectsPerformanceSummaryPageSize,
  setProjectsPerformanceSummaryFromDate,
  setProjectsPerformanceSummaryToDate,
} = reportsSlice.actions;
export default reportsSlice.reducer;
